/* Scent Quiz (Aroma360) — init via initScentQuiz(config) from sections/scent-quiz.liquid */
window.initScentQuiz = function(cfg){
  "use strict";
  var ROOT = document.getElementById("sq-" + cfg.sectionId);
  if(!ROOT) return;

  /* =========================================================
     ONE ART SYSTEM — every tile drawing on a 120 x 76 canvas,
     stroke 2, rendered at 60px. Units use a portrait canvas with
     a stroke tuned to render at the same optical weight.
     ========================================================= */
  function art(body){
    return '<svg viewBox="0 0 120 76" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + body + '</svg>';
  }
  var SOLID = ' fill="currentColor" stroke="none"';
  var SOFT  = ' fill="currentColor" fill-opacity=".18"';
  var GROUND = '<path d="M6 68h108" opacity=".3"/>';

  function home(kind){
    if(kind === "apt"){
      /* mid-rise block with stacked balconies, one unit picked out */
      return art(GROUND +
        '<path d="M34 12h52v56H34z"' + SOFT + '/>' +
        '<path d="M30 8h60v6H30z"' + SOLID + '/>' +
        '<rect x="41" y="20" width="11" height="8"' + SOLID + '/>' +
        '<rect x="56" y="20" width="11" height="8"' + SOLID + '/>' +
        '<rect x="71" y="20" width="11" height="8"' + SOLID + '/>' +
        '<rect x="41" y="34" width="11" height="8"' + SOLID + '/>' +
        '<rect x="56" y="34" width="11" height="8"' + SOLID + '/>' +
        '<rect x="71" y="34" width="11" height="8"' + SOLID + '/>' +
        '<rect x="41" y="48" width="11" height="8"' + SOLID + '/>' +
        '<rect x="71" y="48" width="11" height="8"' + SOLID + '/>' +
        /* balcony rails */
        '<path d="M38 30h48M38 44h48" opacity=".55"/>' +
        /* entrance */
        '<path d="M55 58h10v10H55z"/>');
    }
    if(kind === "s"){
      return art(GROUND +
        '<path d="M46 22h28v46H46z"' + SOFT + '/>' +
        '<path d="M43 17h34v6H43z"' + SOLID + '/>' +
        '<rect x="51" y="29" width="7" height="7"' + SOLID + '/><rect x="62" y="29" width="7" height="7"' + SOLID + '/>' +
        '<rect x="51" y="41" width="7" height="7"' + SOLID + '/><rect x="62" y="41" width="7" height="7"' + SOLID + '/>' +
        '<path d="M55 55h10v13H55z"/>');
    }
    if(kind === "m"){
      return art(GROUND +
        '<path d="M38 38h44v30H38z"' + SOFT + '/>' +
        '<path d="M32 38 60 18l28 20Z"' + SOLID + '/>' +
        '<rect x="45" y="45" width="9" height="9"' + SOLID + '/><rect x="66" y="45" width="9" height="9"' + SOLID + '/>' +
        '<path d="M55 56h10v12H55z"/>');
    }
    if(kind === "l"){
      return art(GROUND +
        '<path d="M20 34h50v34H20z"' + SOFT + '/>' +
        '<path d="M14 34 45 14l31 20Z"' + SOLID + '/>' +
        '<path d="M70 46h30v22H70z"' + SOFT + '/>' +
        '<path d="M66 46 85 32l19 14Z"' + SOLID + '/>' +
        '<rect x="27" y="41" width="9" height="9"' + SOLID + '/><rect x="53" y="41" width="9" height="9"' + SOLID + '/>' +
        '<path d="M39 56h11v12H39z"/><rect x="79" y="52" width="12" height="8"' + SOLID + '/>');
    }
    if(kind === "xl"){
      return art(GROUND +
        '<path d="M26 28h46v40H26z"' + SOFT + '/>' +
        '<path d="M20 28 49 9l29 19Z"' + SOLID + '/>' +
        '<path d="M72 42h28v26H72z"' + SOFT + '/>' +
        '<path d="M68 42 86 29l18 13Z"' + SOLID + '/>' +
        '<path d="M6 50h18v18H6z"' + SOFT + '/>' +
        '<path d="M2 50 15 40l13 10Z"' + SOLID + '/>' +
        '<rect x="33" y="36" width="9" height="9"' + SOLID + '/><rect x="56" y="36" width="9" height="9"' + SOLID + '/>' +
        '<path d="M43 55h12v13H43z"/><rect x="80" y="49" width="12" height="8"' + SOLID + '/>');
    }
    /* business: flat-roofed commercial block with a glazed entrance */
    return art(GROUND +
      '<path d="M16 21h88v47H16z"' + SOFT + '/>' +
      '<path d="M12 15h96v7H12z"' + SOLID + '/>' +
      '<rect x="23" y="28" width="13" height="9"' + SOLID + '/><rect x="43" y="28" width="13" height="9"' + SOLID + '/>' +
      '<rect x="63" y="28" width="13" height="9"' + SOLID + '/><rect x="83" y="28" width="13" height="9"' + SOLID + '/>' +
      '<rect x="23" y="42" width="13" height="9"' + SOLID + '/><rect x="83" y="42" width="13" height="9"' + SOLID + '/>' +
      '<path d="M46 54h28v14H46z"/><path d="M60 54v14"/>' +
      '<path d="M44 50h32" opacity=".55"/>');
  }

  function plan(kind){
    var rooms = {A:"M8 6h50v34H8z", B:"M58 6h54v34H58z", C:"M8 40h68v28H8z", D:"M76 40h36v28H76z"};
    var lit = {hvac:["A","B","C","D"], key:["A","B","C"], one:["A"], unsure:[]}[kind];
    var dots = {A:[[22,20],[36,15],[30,30]], B:[[74,18],[92,26],[101,14]], C:[[24,54],[42,60],[58,50]], D:[[85,54],[98,49],[103,60]]};
    var g = "", n = 0;
    Object.keys(rooms).forEach(function(k){
      g += '<path d="' + rooms[k] + '"' + (lit.indexOf(k) > -1 ? SOFT : "") + '/>';
    });
    lit.forEach(function(k){
      dots[k].forEach(function(pt){
        g += '<circle class="sq-mist" cx="' + pt[0] + '" cy="' + pt[1] + '" r="3.4"' + SOLID +
             ' opacity=".55" style="animation-delay:' + (n * 0.42).toFixed(2) + 's"/>';
        n++;
      });
    });
    if(kind === "hvac"){
      g += '<path d="M48 40H28M68 40h24M58 33V16M58 47v16" stroke-dasharray="4 4" opacity=".6"/>' +
           '<rect x="46" y="32" width="24" height="16" rx="2"' + SOLID + '/>' +
           '<path d="M52 36v8M58 36v8M64 36v8" stroke="#FBF8F5" stroke-width="2"/>';
    } else if(kind === "unsure"){
      g += '<text x="60" y="48" text-anchor="middle" font-family="Lato, sans-serif" font-size="30" font-weight="700"' +
           SOLID + ' opacity=".45">?</text>';
    }
    return art(g);
  }

  /* Official Aroma360 fragrance-profile badge artwork — theme assets, URLs passed from the section. */
  var BADGES = cfg.badges || {};
  function profileArt(kind){
    if(kind === "unsure") return openProfileArt();
    return '<img class="sq-badge" src="' + BADGES[kind] + '" alt="" loading="lazy" decoding="async">';
  }
  /* Six dots on an open ring — one per fragrance profile, none chosen yet. */
  function openProfileArt(){
    var dots = "";
    for(var i=0;i<6;i++){
      var a = (i * 60 - 90) * Math.PI / 180;
      dots += '<circle cx="' + (50 + 31 * Math.cos(a)).toFixed(1) + '" cy="' +
              (50 + 31 * Math.sin(a)).toFixed(1) + '" r="5.4" fill="currentColor" fill-opacity=".55" stroke="none"/>';
    }
    return '<svg class="sq-badge-open" viewBox="0 0 100 100" fill="none" stroke="currentColor" ' +
           'stroke-width="2" aria-hidden="true">' +
             '<circle cx="50" cy="50" r="46" stroke-opacity=".35" stroke-dasharray="5 7"/>' +
             dots +
             '<circle cx="50" cy="50" r="13" stroke-opacity=".5"/>' +
           '</svg>';
  }

  /* ---------------------------------------------------------------
     Official Aroma360 mood icons, inlined from the brand asset set.
     Drawn on a 100 x 100 grid and tinted with currentColor.
     --------------------------------------------------------------- */
  var MOOD_ART = {
    "Relaxed": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M38.62,10.52c.82,1.11.58,2.68-.53,3.5-2.92,2.15-8.56,8.59-7.94,16.81.11,1.38-.93,2.58-2.3,2.68-1.38.11-2.58-.93-2.68-2.3-.81-10.62,6.32-18.53,9.96-21.22,1.11-.82,2.68-.58,3.5.53"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M19.51,35.19c-3.47,1.63-7.12,4.07-9.4,5.82-1.1.84-2.67.63-3.51-.47-.84-1.1-.63-2.67.47-3.51,2.47-1.89,6.42-4.55,10.32-6.37,1.94-.91,3.99-1.67,5.9-1.99,1.85-.3,4.07-.27,5.83,1.08,1.1.84,1.31,2.41.47,3.51-.84,1.1-2.41,1.31-3.51.47-.14-.1-.65-.34-1.98-.12-1.27.21-2.84.76-4.59,1.58"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M28.15,29.05c1.08.86,1.26,2.43.4,3.51-5.98,7.53-4.64,15.6-3.38,18.45.56,1.26-.01,2.74-1.28,3.3-1.26.56-2.74-.01-3.3-1.28-1.84-4.16-3.34-14.29,4.04-23.58.86-1.08,2.43-1.26,3.51-.4"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M19.94,64.88c6.9-7.11,17.24-12.35,32.11-12.35s25.11,5.44,31.68,12.83c6.5,7.31,9.34,16.33,10.14,23.37.45,3.9-2.78,6.82-6.32,6.77l-72.83-.85c-3.6-.04-6.81-3.15-6.12-7.1,1.19-6.88,4.51-15.62,11.35-22.67M23.54,68.36c-5.98,6.17-8.95,13.9-10.01,20.04-.05.31.03.58.24.81.22.24.58.43,1.01.44l72.83.85c.43,0,.79-.17,1.02-.4.22-.22.32-.49.28-.8-.72-6.3-3.27-14.27-8.91-20.62-5.57-6.27-14.33-11.15-27.94-11.15s-22.6,4.73-28.52,10.83"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M25.71,29.36c.91-1.04,2.49-1.14,3.53-.23,2.21,1.93,5.44,5.5,8.22,10.08,2.79,4.59,5.23,10.35,5.63,16.65.09,1.38-.96,2.57-2.33,2.66-1.38.09-2.57-.96-2.66-2.33-.34-5.24-2.39-10.22-4.91-14.38-2.52-4.15-5.42-7.32-7.25-8.92-1.04-.91-1.14-2.49-.23-3.53"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M36.9,22.95c4.1-.73,8.41-.43,11.15.07,1.36.25,2.26,1.55,2.01,2.91-.25,1.36-1.55,2.26-2.91,2.01-2.32-.42-6-.67-9.38-.07-3.45.62-5.9,1.99-6.91,4.18-.57,1.26-2.06,1.81-3.31,1.23-1.26-.57-1.81-2.06-1.23-3.31,2.04-4.44,6.55-6.3,10.58-7.03"/> <path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M62.12,20.01c0-8.56,6.94-15.51,15.51-15.51s15.51,6.94,15.51,15.51-6.94,15.51-15.51,15.51-15.51-6.94-15.51-15.51M77.62,9.5c-5.8,0-10.51,4.7-10.51,10.51s4.7,10.51,10.51,10.51,10.51-4.7,10.51-10.51-4.7-10.51-10.51-10.51"/>',
    "Happy": '<path fill="currentColor" d="M25.69,44.59c-.81,0-1.62-.27-2.3-.82-1.56-1.27-1.8-3.57-.52-5.13,5.18-6.37,14.72-6.52,20.19-.05,1.3,1.54,1.11,3.84-.43,5.14-1.54,1.3-3.84,1.11-5.14-.43-.93-1.09-2.46-2.4-4.5-2.4-1.65,0-3.23.84-4.47,2.35-.72.88-1.77,1.34-2.83,1.34"/> <path fill="currentColor" d="M59.72,44.59c-.81,0-1.62-.27-2.3-.82-1.56-1.27-1.79-3.57-.52-5.13,5.18-6.37,14.72-6.52,20.19-.05,1.3,1.54,1.11,3.84-.43,5.14-1.54,1.3-3.84,1.11-5.14-.43-.93-1.09-2.46-2.4-4.5-2.4-1.65,0-3.23.84-4.47,2.35-.72.88-1.77,1.34-2.83,1.34"/> <path fill="currentColor" d="M50,10.57c-10.71,0-20.78,4.17-28.36,11.74-7.57,7.57-11.74,17.64-11.74,28.36s4.17,20.78,11.74,28.35c7.57,7.57,17.65,11.74,28.36,11.74s20.78-4.17,28.36-11.74c7.57-7.57,11.74-17.64,11.74-28.35s-4.17-20.78-11.74-28.36c-7.57-7.57-17.65-11.74-28.36-11.74M50,98.06c-12.66,0-24.55-4.93-33.51-13.88C-1.98,65.7-1.98,35.63,16.49,17.16,25.45,8.21,37.34,3.28,50,3.28s24.55,4.93,33.51,13.88c18.48,18.47,18.48,48.54,0,67.01-8.95,8.95-20.85,13.88-33.51,13.88"/> <path fill="currentColor" d="M50,73.75c-12.01,0-19.28-7.14-19.59-7.45-1.42-1.42-1.42-3.73,0-5.16,1.42-1.42,3.73-1.42,5.16,0,.21.2,5.54,5.31,14.43,5.31s14.23-5.11,14.45-5.33c1.43-1.4,3.73-1.39,5.14.04,1.41,1.43,1.41,3.71,0,5.13-.3.3-7.59,7.44-19.59,7.44"/>',
    "Comforted": '<path fill="currentColor" d="M21.38,36.6c3.04-13.22,14.86-22.72,28.62-22.72s25.59,9.51,28.62,22.72c11.08,1.97,19.16,11.86,18.62,23.28-.56,12.08-10.57,21.56-22.68,21.53H25.43c-12.11.03-22.11-9.45-22.68-21.53-.53-11.42,7.55-21.31,18.62-23.28M50,19.08c-11.88,0-21.99,8.59-23.87,20.27-.19,1.17-1.15,2.07-2.33,2.17-9.31.84-16.29,8.83-15.86,18.12.43,9.29,8.13,16.6,17.48,16.58h49.16c9.35.02,17.05-7.29,17.48-16.58.43-9.29-6.55-17.28-15.86-18.12-1.18-.11-2.14-1-2.33-2.17-1.88-11.67-11.99-20.27-23.87-20.27"/>',
    "Energized": '<path fill="currentColor" d="M44.81,6.98c1.79-2.43,5.01-3.44,7.93-2.63,2.94.83,5.09,3.37,5.1,6.41l.12,25.64,24.76-.11c2.59-.01,5.04,1.3,6.31,3.51,1.29,2.23,1.13,4.95-.4,7.03l-33.44,45.57c-1.78,2.43-5,3.45-7.93,2.63-2.94-.82-5.09-3.37-5.1-6.41l-.12-25.64-24.76.12c-2.58.01-5.03-1.29-6.31-3.51-1.29-2.23-1.13-4.95.4-7.03L44.81,6.98ZM51.37,8.96c-1-.28-2.04.1-2.55.8L15.38,55.33c-.42.58-.46,1.29-.11,1.89.36.62,1.1,1.07,1.99,1.06l27.23-.13c1.36,0,2.47,1.06,2.48,2.39l.13,28.04c0,.76.55,1.54,1.54,1.82,1,.28,2.04-.09,2.55-.8l33.44-45.57c.42-.57.46-1.29.11-1.88-.36-.62-1.1-1.07-2-1.06l-27.22.13c-1.36,0-2.47-1.06-2.48-2.39l-.13-28.05c0-.76-.55-1.54-1.54-1.82"/>',
    "Romantic": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M49.63,92.97h0v-2.64s0,2.64,0,2.64ZM50.29,18.73c7.09-7.71,17.65-10.85,27.62-8.13,9.96,2.72,17.67,10.83,20.23,21.12,2.56,10.28-.37,21.22-7.74,28.63l-24.44,25.56c-4.31,4.51-10.19,7.07-16.34,7.06-6.15,0-12.03-2.55-16.34-7.06h0l-24.46-25.58s-.03-.03-.04-.04c-10.62-11.57-10.44-29.85.4-41.19,10.91-11.41,28.58-11.6,39.71-.42.01.01.03.03.04.04l.68.71.66-.69ZM76.52,15.68c-8.02-2.19-16.57.32-22.36,6.63l-.04.04-2.59,2.71c-.5.52-1.18.81-1.9.81s-1.41-.29-1.91-.81l-2.57-2.69c-9.04-9.05-23.29-8.9-32.14.36-8.91,9.32-9.07,24.44-.35,33.96l24.44,25.56c3.34,3.5,7.85,5.44,12.53,5.44h0c4.67,0,9.18-1.94,12.53-5.44l24.46-25.58s.02-.03.04-.04c6.04-6.06,8.5-15.11,6.38-23.65-2.13-8.53-8.47-15.12-16.5-17.31"/>',
    "Focused": '<path fill="currentColor" d="M64.68,35.42l14.89.88,8.24-8.93h-11.54c-1.44,0-2.61-1.16-2.61-2.6v-11.87l-8.99,7.61v14.92ZM77.37,4.91c.92.43,1.51,1.35,1.51,2.36v14.88h14.88c1.04,0,1.97.61,2.39,1.56.41.95.23,2.05-.47,2.81l-13.11,14.21c-.53.57-1.29.88-2.07.83l-17.35-1.02-12.28,13.3c-.98,1.06-2.62,1.12-3.68.15-1.06-.98-1.12-2.62-.15-3.68l12.42-13.46v-17.56c0-.77.34-1.5.92-1.99l14.21-12.02c.78-.66,1.86-.8,2.78-.37"/> <path fill="currentColor" d="M50,24.47c-14.1,0-25.53,11.43-25.53,25.53s11.43,25.53,25.53,25.53,25.53-11.43,25.53-25.53c0-1.44,1.17-2.6,2.6-2.6s2.6,1.17,2.6,2.6c0,16.98-13.76,30.74-30.74,30.74s-30.74-13.76-30.74-30.74,13.76-30.74,30.74-30.74c1.44,0,2.6,1.17,2.6,2.6s-1.17,2.6-2.6,2.6"/> <path fill="currentColor" d="M50,8.84c-22.73,0-41.16,18.43-41.16,41.16s18.43,41.16,41.16,41.16,41.16-18.43,41.16-41.16c0-1.44,1.17-2.6,2.6-2.6s2.6,1.17,2.6,2.6c0,25.61-20.76,46.37-46.37,46.37S3.63,75.61,3.63,50,24.39,3.63,50,3.63c1.44,0,2.6,1.17,2.6,2.6s-1.17,2.6-2.6,2.6"/>',
    "Refresh": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width=".5" d="M37.01,76.4c-3.6-3.2-9.62-3.14-12.93.17-3.48,3.48-3.48,9.13,0,12.61,1.53,1.53,4.66,2.48,7.65,1.83,2.75-.6,5.27-2.53,5.95-6.78.22-1.39,1.53-2.34,2.92-2.12,1.39.22,2.34,1.53,2.11,2.92-1.03,6.45-5.22,9.94-9.89,10.96-4.42.97-9.4-.26-12.35-3.2-5.47-5.47-5.47-14.34,0-19.81,5.34-5.34,14.43-5.25,19.92-.38.33.29.57.5.8.67l24.07,17.4c4.25,2.38,9.63.9,12.07-3.32,2.46-4.27,1-9.72-3.26-12.18-2.02-1.17-5.12-1.41-7.67-.31-2.35,1.01-4.3,3.18-4.3,7.23,0,1.41-1.14,2.55-2.55,2.55s-2.55-1.14-2.55-2.55c0-6.13,3.2-10.11,7.38-11.91,3.98-1.71,8.77-1.42,12.24.58,6.7,3.87,9,12.44,5.13,19.14-3.87,6.7-12.44,9-19.14,5.13l-.11-.07-24.29-17.56c-.47-.34-.88-.7-1.2-.99M27.59,45.39c4.5-5.99,11.81-10.69,22.93-10.69s18.43,4.7,22.93,10.69c4.41,5.87,6.03,12.86,6.19,17.57.04,1.24-.82,2.34-2.05,2.58-2.86.57-9.82,1.77-14.21,1.77-2.81,0-5.9-1.49-8.32-2.95-1.68-1.01-3.26-2.15-4.54-3.16-1.28,1.01-2.86,2.15-4.53,3.16-2.42,1.46-5.51,2.95-8.32,2.95-4.39,0-11.35-1.2-14.21-1.77-1.22-.25-2.09-1.34-2.04-2.58.15-4.71,1.77-11.69,6.18-17.57M26.68,60.95c3.25.57,7.95,1.25,10.98,1.25,1.3,0,3.35-.81,5.69-2.21,2.22-1.34,4.28-2.96,5.47-4.02.96-.86,2.43-.86,3.39,0,1.19,1.06,3.25,2.68,5.47,4.02,2.34,1.41,4.39,2.21,5.69,2.21,3.03,0,7.73-.68,10.98-1.25-.49-3.72-1.96-8.47-4.99-12.51-3.57-4.75-9.4-8.65-18.85-8.65s-15.28,3.9-18.85,8.65c-3.03,4.04-4.5,8.79-4.99,12.51M35.67,17.88c0-8.16,6.62-14.77,14.78-14.77s14.78,6.62,14.78,14.77-6.62,14.78-14.78,14.78-14.78-6.62-14.78-14.78M50.45,8.2c-5.35,0-9.68,4.33-9.68,9.68s4.33,9.68,9.68,9.68,9.68-4.33,9.68-9.68-4.33-9.68-9.68-9.68"/>',
    "Playful": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width=".75" d="M78.69,46.37c1-1,2.62-1,3.62,0l8.19,8.19c1,1,1,2.62,0,3.62-1,1-2.62,1-3.62,0l-8.19-8.19c-1-1-1-2.62,0-3.62M95.7,32c.39,1.36-.4,2.78-1.76,3.16l-12.75,3.64c-1.36.39-2.78-.4-3.16-1.76s.4-2.78,1.76-3.16l12.74-3.64c1.36-.39,2.78.4,3.17,1.76M28.96,83.09l-11.67-11.67-6.34,18.07,18.01-6.4ZM50.17,75.56l-25.42-25.42-5.59,15.93,15.13,15.13,15.88-5.64ZM32.39,28.33l-5.77,16.45,28.88,28.88,15.8-5.61L32.39,28.33ZM30.78,21.1c.86-.19,1.76.08,2.38.71l44.6,45.51c.61.63.86,1.52.67,2.37-.2.85-.81,1.54-1.64,1.83L7.62,96.1c-.93.33-1.96.1-2.66-.6-.7-.69-.94-1.73-.61-2.66L28.92,22.75c.29-.83,1-1.46,1.86-1.65M82.6,8.32c1.41.15,2.42,1.42,2.26,2.82-.17,1.53-.62,3.88-1.44,6.09-.41,1.11-.95,2.26-1.64,3.28-.68,1-1.61,2.02-2.87,2.64-2.31,1.15-4.66.99-6.33.87-.19-.01-.37-.03-.54-.04-1.79-.1-3.19-.07-4.79.89-1.12.67-2.14,2.11-2.93,4.04-.77,1.87-1.17,3.81-1.3,4.97-.15,1.4-1.42,2.42-2.82,2.26-1.4-.15-2.42-1.42-2.26-2.83.17-1.57.68-3.99,1.66-6.36.95-2.3,2.51-4.96,5.03-6.48,2.96-1.77,5.65-1.73,7.73-1.61.15,0,.29.02.42.03,1.91.11,2.86.17,3.86-.33.2-.1.53-.36.93-.95.39-.57.75-1.32,1.07-2.19.65-1.75,1.02-3.67,1.15-4.88.16-1.4,1.42-2.42,2.82-2.26M51.36,3.75c1.41,0,2.56,1.15,2.56,2.56v13.65c0,1.41-1.15,2.56-2.56,2.56s-2.56-1.15-2.56-2.56V6.31c0-1.41,1.15-2.56,2.56-2.56"/>',
    "Grounded": '<path fill="currentColor" d="M64.43,45.84c1.28.6,1.83,2.13,1.22,3.41-6.34,13.42-17.31,24.27-28.19,32.48-10.9,8.23-21.87,13.92-28.44,16.96-1.28.59-2.81.03-3.4-1.25-.59-1.28-.03-2.81,1.25-3.4,6.36-2.94,16.99-8.46,27.5-16.4,10.54-7.95,20.8-18.21,26.64-30.58.6-1.28,2.13-1.83,3.41-1.22"/> <path fill="currentColor" d="M88.43,18.11s0,0-.02,0c.01,0,.02,0,.02,0M89.98,13.22c.46.15,1.13.43,1.68.98.76.76,1.14,1.83,1.37,2.6.26.88.46,1.92.63,3.03.33,2.23.54,5.01.68,7.89.28,5.77.28,12.23.28,16.12v.02c0,8.54-4.76,27.18-24.33,41.08-8.06,5.73-17.19,7.67-25.21,7.83-8.01.15-15.09-1.47-19.26-3.07-1.32-.51-1.98-1.99-1.48-3.31.51-1.32,1.99-1.98,3.31-1.48,3.58,1.37,10,2.87,17.33,2.72,7.31-.14,15.34-1.91,22.34-6.88,18.07-12.84,22.17-29.84,22.17-36.9,0-3.91,0-10.25-.27-15.89-.14-2.83-.34-5.41-.63-7.39-.15-1-.31-1.77-.47-2.33-.02-.09-.05-.17-.07-.24-.07-.01-.16-.02-.26-.04-.67-.08-1.65-.11-2.92-.05-2.52.11-5.88.54-9.59,1.29-7.48,1.51-15.98,4.21-21.68,7.86-11.84,7.58-18.19,15.08-22.4,22.5-2,3.53-3.6,9.04-4.7,14.55-1.09,5.47-1.61,10.59-1.61,13.15,0,1.42-1.15,2.57-2.57,2.57s-2.56-1.15-2.56-2.57c0-3.01.58-8.48,1.71-14.14,1.12-5.63,2.84-11.82,5.27-16.09,4.64-8.17,11.58-16.27,24.1-24.28,6.48-4.15,15.69-7.01,23.43-8.57,3.9-.78,7.53-1.26,10.37-1.39,1.42-.06,2.71-.05,3.78.08.53.06,1.08.17,1.58.33"/> <path fill="currentColor" d="M22.52,22.13c1.34-.45,2.8.28,3.24,1.62,2.7,8.1,4.01,19.49,2.69,30.85-.16,1.41-1.44,2.41-2.84,2.25-1.41-.16-2.41-1.44-2.25-2.84,1.25-10.67-.01-21.31-2.46-28.63-.45-1.34.28-2.8,1.62-3.24"/> <path fill="currentColor" d="M22,2.13l1.33.64c16.14,7.75,19.34,24.17,18.94,31.46-.08,1.41-1.29,2.5-2.7,2.42-1.41-.08-2.5-1.29-2.42-2.7.32-5.89-2.26-19.08-14.67-25.86-4.19,3.43-11.17,11.85-11.91,23.92-.54,8.86,3.27,17.9,8.93,23.57,1,1,1,2.62,0,3.63s-2.63,1-3.63,0c-6.64-6.64-11.06-17.1-10.43-27.5.94-15.26,10.47-25.43,15.33-28.74l1.22-.83Z"/>',
    "Inspired": '<path fill="currentColor" d="M35.23,65.43v12.72c0,.89.71,1.61,1.6,1.61h28.53c.88,0,1.6-.72,1.6-1.61v-12.72h-31.72ZM29.76,64.86c0-2.73,2.19-4.94,4.9-4.94h32.86c2.71,0,4.9,2.21,4.9,4.94v13.29c0,3.93-3.16,7.12-7.07,7.12h-28.53c-3.9,0-7.07-3.19-7.07-7.12v-13.29Z"/> <path fill="currentColor" d="M43.31,44.78c1.35-.68,2.99-.13,3.67,1.23l6.56,13.23c.67,1.36.13,3.02-1.22,3.7-1.35.68-2.99.13-3.67-1.23l-6.56-13.23c-.68-1.36-.13-3.02,1.22-3.7"/> <path fill="currentColor" d="M40.7,85.27v5.01c0,.89.71,1.61,1.6,1.61h16.49c.88,0,1.6-.72,1.6-1.61v-5.01h-19.69ZM35.23,79.76h30.63v10.52c0,3.93-3.16,7.12-7.07,7.12h-16.49c-3.9,0-7.07-3.19-7.07-7.12v-10.52Z"/> <path fill="currentColor" d="M69.98,11.33c5.42,5.19,9,12.25,9,19.54s-2.56,13.69-5.16,17.93c-2.05,3.33-3.73,6.45-4.27,9.75l-1.12,6.78-5.4-.9,1.12-6.78c.74-4.46,2.95-8.38,5.01-11.75,2.22-3.61,4.35-8.8,4.35-15.03,0-5.47-2.73-11.17-7.3-15.54-4.55-4.36-10.74-7.22-17.31-7.22V2.6c8.15,0,15.64,3.52,21.08,8.73"/> <path fill="currentColor" d="M29.28,11.41c-5.01,5.21-8.27,12.25-8.27,19.46s2.38,13.71,4.8,17.96c1.85,3.24,3.36,6.25,3.84,9.41l1.07,7.07,5.4-.83-1.07-7.07c-.65-4.26-2.64-8.05-4.5-11.32-2.06-3.62-4.07-8.87-4.07-15.21,0-5.55,2.55-11.27,6.73-15.62,4.17-4.34,9.78-7.13,15.69-7.13V2.6c-7.64,0-14.6,3.59-19.62,8.81"/> <path fill="currentColor" d="M58.88,44.78c1.35.68,1.9,2.34,1.22,3.7l-6.56,13.23c-.68,1.36-2.32,1.91-3.67,1.23-1.35-.68-1.9-2.34-1.22-3.7l6.56-13.23c.67-1.36,2.32-1.91,3.67-1.23"/>',
    "Tranquil": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" d="M31.61,35.59c.95-9.34,8.11-20.48,15.17-26.47,1.18-1,2.56-2.51,4.18-1.92.53.19,3.76,3.08,4.38,3.69,8.93,8.74,14.86,21.15,13.07,33.9,6.86-2.67,14.27-2.42,21.3-.48,2.25.62,6.6,1.47,6.46,4.18-.22,4.57-3.35,10.07-5.2,14.19,6,4.08,8.64,11,3.58,17.14-6.86,8.35-23.42,11.82-33.74,12.74-1.55.14-5.46.62-6.71.26-1.33-.38-3.12-6.24-3.78-7.68-.74-.14-.51.05-.71.41-.91,1.65-1.76,5.49-2.81,6.78-.84,1.03-6.08.36-7.6.23-10.35-.93-27.35-4.5-34.05-13.08-4.76-6.09-1.79-12.74,3.82-16.82-2.07-3.9-4.11-7.96-5.03-12.32-.82-3.91.15-3.62,3.61-4.91,7.78-2.9,16.33-3.42,24.21-.64.5-.17-.16-.73-.16-.81,0-2.61-.26-5.88,0-8.39ZM49.89,10.92c-9.18,7.46-15.77,18.65-15.07,30.82.45,7.79,4.15,15.62,9.21,21.45.76.88,4.44,4.76,5.15,5.18.34.2.51.37.97.32.58-.06,5.26-4.83,5.98-5.67,5.93-6.91,9.57-15.96,9.06-25.18-.57-10.33-7.16-20.86-15.3-26.91ZM53.23,70.92c13.5,4.81,27.47,1.73,34.99-11,.99-1.68,4.79-9.87,3.92-11.27-7.46-3.3-16.71-3.75-24.19-.28-.67.55-1.93,4.92-2.5,6.21-2.83,6.34-7.37,11.5-12.22,16.34ZM32.82,49.06c-6.07-3.15-12.97-3.29-19.55-1.8-1.27.29-4.97,1.21-5.87,1.88-.54.41.56,3.54.83,4.34,1.83,5.49,5.8,11.57,10.5,14.99,8.6,6.27,18.72,6.08,28.37,2.44-6.47-5.95-12.07-13.19-14.28-21.86ZM48.39,74.16c-13.48,4.52-28.11,2.88-37.32-8.69-10.63,7.7-2.38,14.72,6.12,18.43,8.49,3.71,18.11,5.03,27.29,5.72l3.91-9.16v-6.29ZM51.62,73.83v6.62l3.91,9.16c10.55-.84,22.84-2.43,32.01-8.09,7.1-4.39,9.29-10.99,1.4-16.05-9.19,11.2-24.14,13.39-37.32,8.37Z"/>',
    "Cozy": '<path fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" d="M15.33,59.46c.31-.3-1.32-2.24-1.57-2.76-6.91-14.14,4.05-30.54,19.78-27.32,5.11,1.05,6.43,3,9.67,6.46.3.32.27.34.79.24,3.19-25.1,40.94-27.45,49.7-4.62,3.65,9.5,1.55,20.8-5.94,27.82,13.37,4.93,10.64,23.61-3.57,24.34-21.74-1.26-45.26,1.61-66.79,0C.18,82.32-1.51,61.7,15.33,59.46ZM45.51,48.52c-.42,6.56-8.39,11.56-14.22,7.99-4.11-2.52-5.5-7.4-3.28-11.73.52-1.02,2.1-3.41,3.39-2.33,1.52,1.27-.48,2.72-1.04,3.93-3.29,7.1,6.67,12.27,11.32,4.91,4.76-7.54-.82-18.3-9.6-19.32-14.67-1.72-22.9,14.54-14.26,25.95.98,1.29,3.35,2.52,2.75,4.31-.54,1.6-2.27.34-3.19.28-4.25-.26-7.98.52-9.97,4.68-3.31,6.88,2.04,12.71,8.86,13.41h69.41c9.94-1.74,10.85-15.08,1.4-18.39-1.17-.41-4.13-.34-4.26-1.81-.11-1.17,3.53-3.69,4.56-4.88,9.95-11.48,5.34-29.94-8.86-35.28-14.32-5.39-32.41,2.56-32.27,19.41.16,18.64,28.58,19.22,28.31,2.3-.1-6.45-8.08-12.42-13.04-7.01-2.48,2.7-.49,4.66-.96,6.17-.51,1.61-2.75,1.34-2.99-1.42-.63-7.2,5.8-11.31,12.29-8.9,10.68,3.98,8.96,19.99-.7,24.6-8.58,4.1-18.26.59-23.64-6.86Z"/>',
    "Clarity": '<path fill="currentColor" d="M38.57,48.4c7.34,7.25,25.39,3.76,35.55,4.39,25.13,1.56,29.51,33.77,8.05,41.9-2.64,1-10.53,3.19-10.83-1.33-.21-3.12,2.57-2.8,4.39-3.14,20.36-3.86,18.47-30.23-1.92-31.53-15.46-.98-36.69,5.21-44.06-13.14-6.76-16.86,8.3-33.71,25.8-29.08,11.37,3.01,17.07,14.35,15.78,25.64-.49,4.27-5.52,4.14-5.92.66-.68-5.81.95-9.53-3.14-14.94-13.58-17.93-39.25,5.2-23.69,20.57Z"/> <path fill="currentColor" d="M63,91.03c1.95,1.79.24,5.29-2.36,5.15-12.14-.95-26.52,1.45-38.37-.42C.6,92.35-2.71,62.15,17.75,54.28c2.67-1.03,10.52-3.29,10.83,1.33.25,3.74-4.69,3.02-7.15,3.66-15.92,4.15-15.04,27.75,1.45,30.63,11.51,2.01,26.39-.96,38.1.36.61.07,1.59.37,2.03.77Z"/> <path fill="currentColor" d="M49.22,3.54c4.32-.71,4.74,7.36.54,7.49-3.87.12-4.28-6.88-.54-7.49Z"/> <path fill="currentColor" d="M17.98,34.45c.81-.18,2.67-.18,3.48,0,2.75.61,2.59,5.19-.66,5.77-5.44.97-5.97-5.06-2.81-5.77Z"/> <path fill="currentColor" d="M26.85,12.76c3.74-1.11,7,4.32,3.69,6.31-2.56,1.54-6.02-1.67-5.51-4.17.13-.61,1.23-1.97,1.82-2.14Z"/> <path fill="currentColor" d="M70.24,12.76c3.15-.95,5.23,2.01,3.39,4.7-3.01,4.39-7.85.86-5.74-2.45.25-.39,1.99-2.14,2.35-2.25Z"/> <path fill="currentColor" d="M78.13,34.45c4.4-.99,7.28,2.91,3.88,5.19-4.9,3.28-8.59-4.13-3.88-5.19Z"/>'
  };
  /* the quiz labels one profile "Refreshed"; the asset is named "Refresh" */
  var MOOD_ALIAS = {Refreshed:"Refresh"};

  function moodIcon(mood){
    var body = MOOD_ART[MOOD_ALIAS[mood] || mood] || MOOD_ART.Happy;
    return '<svg viewBox="0 0 100 100" aria-hidden="true">' + body + '</svg>';
  }

  function calendar(filled){
    var g = '<path d="M46 12v9M74 12v9"/>' +
            '<rect x="34" y="17" width="52" height="47" rx="3"/>' +
            '<path d="M34 30h52"/><rect x="34" y="17" width="52" height="13" rx="3"' + SOLID + ' opacity=".85"/>';
    var i = 0;
    for(var r=0;r<3;r++){
      for(var c=0;c<3;c++){
        g += '<rect x="' + (40 + c*15) + '" y="' + (35 + r*10) + '" width="11" height="7"' +
             (i < filled ? SOLID : ' opacity=".38"') + '/>';
        i++;
      }
    }
    return art(g);
  }

  function unit(tier){
    var d = {davinci:{y:40,w:28,arcs:2}, vangogh:{y:30,w:34,arcs:3}, museum:{y:20,w:40,arcs:3}, museumxl:{y:12,w:46,arcs:4}}[tier];
    var x = (80 - d.w)/2, bot = 100;
    var g = '<rect x="' + x + '" y="' + d.y + '" width="' + d.w + '" height="' + (bot-d.y) + '" rx="3"' + SOFT + '/>' +
            '<path d="M' + (x+5) + ' ' + (d.y+9) + 'h' + (d.w-10) + '" opacity=".55"/>' +
            '<rect x="' + (x+6) + '" y="' + (bot-15) + '" width="' + (d.w-12) + '" height="3"' + SOLID + ' opacity=".55"/>' +
            '<rect x="' + (x+6) + '" y="' + (bot-9) + '" width="' + (d.w-12) + '" height="3"' + SOLID + ' opacity=".55"/>' +
            '<circle cx="40" cy="' + (bot-22) + '" r="2.6"' + SOLID + '/>';
    for(var i=0;i<d.arcs;i++){
      var r = 9 + i*7;
      g += '<path d="M' + (40-r) + ' ' + (d.y-4) + 'a' + r + ' ' + (r*0.6) + ' 0 0 1 ' + (r*2) + ' 0" opacity="' + (0.7 - i*0.18) + '"/>';
    }
    if(tier !== "davinci"){
      g += '<path d="M' + (x+d.w) + ' ' + (d.y+14) + 'h9v9h-9" opacity=".55"/>';
    }
    return '<svg viewBox="0 0 80 110" fill="none" stroke="currentColor" stroke-width="1.8" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + g + '</svg>';
  }

  function icon24(d){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  function chipIcon(kind){
    var p = {
      candles:'<path d="M8 11h8v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" fill="currentColor" fill-opacity=".18"/>' +
              '<path d="M12 11V9.2"/><path d="M12 8.8c1.6-1.3 1.9-3 0-5.1-1.9 2.1-1.6 3.8 0 5.1Z" fill="currentColor" stroke="none"/>' +
              '<path d="M8 14.6h8" opacity=".5"/>',
      plugin: '<rect x="7" y="9" width="10" height="12" rx="1.4" fill="currentColor" fill-opacity=".18"/>' +
              '<path d="M10 9V4.6M14 9V4.6"/><rect x="10" y="13" width="4" height="1.6" fill="currentColor" stroke="none" opacity=".7"/>',
      reed:   '<path d="M9.6 12.4h4.8V19a2 2 0 0 1-2 2h-.8a2 2 0 0 1-2-2Z" fill="currentColor" fill-opacity=".18"/>' +
              '<path d="M10.6 12.4V10h2.8v2.4"/><path d="M12 10 8.6 3.2M12 10V2.6M12 10l3.4-6.8"/>',
      small:  '<rect x="8" y="6.4" width="8" height="14.6" rx="1.6" fill="currentColor" fill-opacity=".18"/>' +
              '<path d="M10 9.8h4" opacity=".6"/><circle cx="12" cy="17.4" r="1.3" fill="currentColor" stroke="none"/>' +
              '<path d="M9.2 4.4c.9.9 1.7.9 2.5 0M12.9 4.4c.9.9 1.7.9 2.5 0" opacity=".55"/>',
      none:   '<circle cx="12" cy="12" r="7.6" fill="currentColor" fill-opacity=".1"/><path d="M6.9 17.1 17.1 6.9" opacity=".7"/>',

      office:     '<path d="M5 21V5h9v16" fill="currentColor" fill-opacity=".14"/><path d="M14 10h5v11" fill="currentColor" fill-opacity=".14"/>' +
                  '<rect x="7.4" y="8" width="2.4" height="2.4" fill="currentColor" stroke="none"/><rect x="11" y="8" width="2.4" height="2.4" fill="currentColor" stroke="none"/>' +
                  '<rect x="7.4" y="13" width="2.4" height="2.4" fill="currentColor" stroke="none"/><rect x="15.4" y="13" width="2.4" height="2.4" fill="currentColor" stroke="none"/>' +
                  '<path d="M3 21h18"/>',
      retail:     '<path d="M6 9h12l1 12H5Z" fill="currentColor" fill-opacity=".16"/><path d="M9 9a3 3 0 0 1 6 0"/>' +
                  '<path d="M4 6.6h16l-1 2.4H5Z" fill="currentColor" stroke="none"/>',
      gym:        '<path d="M4 9.6v4.8M20 9.6v4.8"/><rect x="6.4" y="7" width="2.8" height="10" rx="1" fill="currentColor" fill-opacity=".2"/>' +
                  '<rect x="14.8" y="7" width="2.8" height="10" rx="1" fill="currentColor" fill-opacity=".2"/>' +
                  '<rect x="9.2" y="11" width="5.6" height="2" fill="currentColor" stroke="none"/>',
      restaurant: '<path d="M7 3v7.4M10 3v7.4M8.5 10.4V21"/><path d="M16.4 3c1.9.6 2.4 3.4 2.4 6.2 0 1.6-.9 2.4-2.4 2.6V21"/>',
      hotel:      '<path d="M3 20v-9M3 15h18v5M21 20v-5a3 3 0 0 0-3-3h-7v3" fill="currentColor" fill-opacity=".14"/>' +
                  '<circle cx="7.2" cy="12" r="2.2" fill="currentColor" stroke="none"/>',
      other:      '<rect x="3.6" y="5.6" width="16.8" height="12.8" rx="2" fill="currentColor" fill-opacity=".12"/>' +
                  '<circle cx="8" cy="12" r="1.4" fill="currentColor" stroke="none"/>' +
                  '<circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/>' +
                  '<circle cx="16" cy="12" r="1.4" fill="currentColor" stroke="none"/>'
    };
    return icon24(p[kind]);
  }
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7"/></svg>';

  /* ===== DATA ===== */
  var DIFFUSERS = {
    davinci: {key:"davinci", name:"DaVinci 2.0",  cover:"1,200 sq ft",  oil:"200 mL",
              tech:"Standalone",          install:"standalone"},
    vangogh: {key:"vangogh", name:"VanGogh 2.0",  cover:"1,800 sq ft",  oil:"500 mL",
              tech:"Standalone or HVAC",  install:"hybrid"},
    museum:  {key:"museum",  name:"Museum 2.0",   cover:"3,000 sq ft",  oil:"500 mL",
              tech:"HVAC-integrated",     install:"hvac"},
    museumxl:{key:"museumxl",name:"Museum360 XL", cover:"6,000+ sq ft", oil:"2 x 500 mL",
              tech:"HVAC-integrated",     install:"hvac"}
  };

  var PROFILES = {
    floral:  {name:"Floral", colorName:"Bloom", color:"#C58D9F", rgb:"197,141,159", mood:"Romantic",
              benefit:"Rose, jasmine and ylang-ylang create feelings of romance and intimacy.",
              vocab:["Light","Soft","Romantic","Elegant"]},
    fruity:  {name:"Fruity", colorName:"Apricot", color:"#B36049", rgb:"179,96,73", mood:"Playful",
              benefit:"Sweet, sun-ripened fruit evokes a lighthearted, playful mood.",
              vocab:["Juicy","Sweet","Playful","Ripe"]},
    citrus:  {name:"Citrus", colorName:"Grove", color:"#909160", rgb:"144,145,96", mood:"Happy",
              benefit:"Lemon, orange and bergamot uplift and energize, sparking joy.",
              vocab:["Tangy","Bright","Zesty","Energizing"]},
    fresh:   {name:"Fresh", colorName:"Breeze", color:"#748CA2", rgb:"116,140,162", mood:"Refreshed",
              benefit:"Linen, ocean breeze and cucumber give a crisp, clean feeling.",
              vocab:["Pure","Clean","Breezy","Cool"]},
    woody:   {name:"Woody", colorName:"Earth", color:"#715C59", rgb:"113,92,89", mood:"Grounded",
              benefit:"Patchouli, pine and vetiver promote stability and a connection to nature.",
              vocab:["Earthy","Warm","Smoky","Deep"]},
    gourmand:{name:"Gourmand", colorName:"Honey", color:"#AC7E37", rgb:"172,126,55", mood:"Comforted",
              benefit:"Vanilla, cinnamon and warm spice evoke nostalgia and comfort.",
              vocab:["Cozy","Rich","Velvety","Decadent"]},
    /* open: no profile chosen — the consultant samples across all six on the call */
    unsure:  {name:"Not sure yet", colorName:"Toffee", color:"#A48776", rgb:"164,135,118",
              mood:"Inspired", open:true, spec:"GUIDE ME",
              benefit:"Your consultant will walk you through all six profiles and sample them with you before you choose.",
              vocab:["Guided","Open","Sampled","Unhurried"]}
  };

  var SIZES = [
    {v:"apt",name:"Apartment",   spec:"UP TO 500 SQ FT",   desc:"Rented unit — no access to the building's HVAC",
     art:function(){return home("apt");}},
    {v:"s",  name:"Condo",       spec:"UP TO 600 SQ FT",   desc:"Owned unit, one or two bedrooms",
     art:function(){return home("s");}},
    {v:"m",  name:"Home",        spec:"UP TO 1,200 SQ FT", desc:"A standard house or townhouse",
     art:function(){return home("m");}},
    {v:"l",  name:"Large home",  spec:"UP TO 3,000 SQ FT", desc:"Multiple floors or a wide footprint",
     art:function(){return home("l");}},
    {v:"xl", name:"Estate",      spec:"UP TO 6,000 SQ FT", desc:"Large property, often zoned HVAC",
     art:function(){return home("xl");}},
    {v:"biz",name:"A business",  spec:"ANY COMMERCIAL SPACE", desc:"Office, retail, gym, restaurant or hotel",
     biz:true, art:function(){return home("biz");}}
  ];

  var VENUES = [
    {v:"office", lbl:"Office"}, {v:"retail", lbl:"Retail"}, {v:"gym", lbl:"Gym"},
    {v:"restaurant", lbl:"Restaurant"}, {v:"hotel", lbl:"Hotel"}, {v:"other", lbl:"Other"}
  ];
  /* commercial spaces move more air, so they start at the HVAC-integrated tier */
  var VENUE_UNIT  = {office:"vangogh", retail:"vangogh", restaurant:"museum", gym:"museum", hotel:"museumxl", other:"vangogh"};
  var INSTALL_LABEL = {standalone:"Standalone only", hybrid:"Standalone or HVAC-integrated", hvac:"HVAC-integrated only"};
  var VENUE_LABEL = {office:"Office", retail:"Retail", gym:"Gym", restaurant:"Restaurant", hotel:"Hotel", other:"Other"};

  var USING = [
    {v:"candles", lbl:"Candles"}, {v:"plugin", lbl:"Plug-ins"}, {v:"reed", lbl:"Reeds"},
    {v:"small", lbl:"Small diffuser"}, {v:"none", lbl:"Nothing"}
  ];
  var SPEND = [
    {v:"lo", lbl:"$0–25", n:1}, {v:"mid", lbl:"$25–50", n:2},
    {v:"hi", lbl:"$50–100", n:3}, {v:"vhi", lbl:"$100+", n:4}
  ];

  var QUESTIONS = [
    {key:"sizes", title:'What are you <em>scenting</em>?', multi:true, hint:"Select all that apply"},
    {key:"method", title:'How far should it <em>spread</em>?',
     tiles:[
       {v:"hvac",  name:"Everywhere",   spec:"RUNS OFF YOUR A/C",
        desc:"Living room, bedrooms, kitchen and hallways at once",
        art:function(){return plan("hvac");}},
       {v:"key",   name:"A few rooms",  spec:"3–4 ZONES",
        desc:"Living room, primary bedroom and entryway",
        art:function(){return plan("key");}},
       {v:"one",   name:"One room",     spec:"1 ZONE",
        desc:"Just the living room, or just the bedroom",
        art:function(){return plan("one");}},
       {v:"unsure",name:"Not sure",     spec:"GUIDE ME",
        desc:"Your consultant maps the rooms with you",
        art:function(){return plan("unsure");}}
     ]},
    {key:"scent", title:'Which one feels like <em>home</em>?', scent:true},
    {key:"__pair", title:'What do you use <em>now</em>?', pair:true},
    {key:"timeline", title:'How soon would you like to <em>get started</em>?',
     tiles:[
       {v:"today",   name:"Today",       spec:"ASAP",           art:function(){return calendar(1);}},
       {v:"asap",    name:"This week",    spec:"WITHIN 7 DAYS",  art:function(){return calendar(2);}},
       {v:"30",      name:"This month",   spec:"WITHIN 30 DAYS", art:function(){return calendar(4);}},
       {v:"90",      name:"Few months",   spec:"1–3 MONTHS",     art:function(){return calendar(9);}},
       {v:"explore", name:"Just looking", spec:"NO RUSH", wide:true, art:function(){return calendar(0);}}
     ]}
  ];

  var SPEND_LABEL  = {lo:"Under $25/mo", mid:"$25–50/mo", hi:"$50–100/mo", vhi:"$100+/mo"};
  var SPEND_MID    = {lo:18, mid:38, hi:75, vhi:130};
  var SIZE_LABEL   = {apt:"Apartment (up to 500 sq ft, rented)", s:"Condo (up to 600 sq ft)",
                      m:"Home (up to 1,200 sq ft)", l:"Large home (up to 3,000 sq ft)",
                      xl:"Estate (up to 6,000 sq ft)", biz:"Business"};
  var METHOD_LABEL = {hvac:"HVAC — everywhere", key:"3–4 rooms", one:"One room", unsure:"Undecided — wants guidance"};
  var CURRENT_LABEL= {candles:"Candles", plugin:"Plug-ins", reed:"Reed diffusers", small:"A small diffuser", none:"Nothing currently"};
  var TIME_LABEL   = {today:"Today — ASAP", asap:"This week", "30":"Within 30 days",
                      "90":"1–3 months", explore:"Just looking"};
  var RESI_ORDER   = ["apt","s","m","l","xl"];

  var state = {sizes:[], venue:null, method:null, scent:null, current:null, spend:null, timeline:null};
  var lead  = {fn:"", ln:"", em:"", ph:"", st:"", ci:"", sr:"", zp:""};
  var step = 0;

  var el = {
    rail:ROOT.querySelector("#rail"),
    quiz:ROOT.querySelector("#quiz"), eyebrow:ROOT.querySelector("#q-eyebrow"),
    title:ROOT.querySelector("#q-title"), body:ROOT.querySelector("#q-body"),
    back:ROOT.querySelector("#back"), cont:ROOT.querySelector("#continue"),
    reveal:ROOT.querySelector("#reveal"), result:ROOT.querySelector("#result")
  };

  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
  function hasBiz(){ return state.sizes.indexOf("biz") > -1; }
  function resiSizes(){ return state.sizes.filter(function(v){ return v !== "biz"; }); }

  function buildRail(){
    var h = "";
    for(var i=0;i<5;i++){ h += '<div class="sq-tick"><span class="sq-num">0'+(i+1)+'</span><span class="sq-bar"></span></div>'; }
    el.rail.innerHTML = h;
  }
  function paintRail(){
    var t = el.rail.querySelectorAll(".sq-tick");
    for(var i=0;i<t.length;i++){
      t[i].className = (step >= 5) ? "sq-tick sq-done" : "sq-tick" + (i < step ? " sq-done" : (i === step ? " sq-now" : ""));
    }
  }

  function renderQuestion(){
    var q = QUESTIONS[step];
    if(!started){ started = true; track("quiz_start"); }
    el.eyebrow.textContent = "0" + (step+1) + " / 05" + (q.hint ? "  ·  " + q.hint : "");
    el.title.innerHTML = q.title;
    el.body.innerHTML = "";
    el.cont.hidden = true;

    if(q.multi){ renderSizes(); }
    else if(q.pair){ renderPair(); }
    else if(q.scent){ renderScent(); }
    else { renderTiles(q); }

    el.back.hidden = (step === 0);
    paintRail();
  }

  function tileButton(pressed, extra){
    var b = document.createElement("button");
    b.type = "button";
    b.className = "sq-tile" + (extra || "");
    b.setAttribute("aria-pressed", pressed ? "true" : "false");
    return b;
  }
  function tileInner(artSVG, name, spec, withCheck, opts){
    opts = opts || {};
    var specHTML = opts.mood
      ? '<span class="sq-spec sq-mood-spec">' + moodIcon(spec) + '<span>' + esc(spec) + '</span></span>'
      : '<span class="sq-spec">' + esc(spec) + '</span>';
    return (withCheck ? '<span class="sq-check">' + TICK + '</span>' : "") +
           '<span class="sq-plate">' + artSVG + '</span>' +
           '<span class="sq-meta"><span class="sq-name">' + esc(name) + '</span>' +
           specHTML +
           (opts.desc ? '<span class="sq-desc">' + esc(opts.desc) + '</span>' : "") +
           '</span>';
  }

  /* ---------- Q1: multi-select, with venue chips when business is on ---------- */
  function renderSizes(){
    var grid = document.createElement("div");
    grid.className = "sq-tiles";
    grid.setAttribute("role","group");
    grid.setAttribute("aria-label","Select all that apply");

    SIZES.forEach(function(t){
      var on = state.sizes.indexOf(t.v) > -1;
      var b = tileButton(on, (t.wide ? " sq-wide" : "") + (t.biz ? " sq-biz" : ""));
      b.innerHTML = tileInner(t.art(), t.name, t.spec, true, {desc:t.desc});
      b.addEventListener("click", function(){
        var i = state.sizes.indexOf(t.v);
        if(i > -1){ state.sizes.splice(i,1); } else { state.sizes.push(t.v); }
        if(!hasBiz()){ state.venue = null; }
        b.setAttribute("aria-pressed", state.sizes.indexOf(t.v) > -1 ? "true" : "false");
        syncVenue();
        syncContinue();
      });
      grid.appendChild(b);
    });

    var slot = document.createElement("div");
    slot.id = "venueSlot";
    slot.className = "sq-venueslot";
    grid.appendChild(slot);

    el.body.appendChild(grid);

    el.cont.hidden = false;
    syncVenue();
    syncContinue();
  }

  function syncVenue(){
    var slot = ROOT.querySelector("#venueSlot");
    if(!slot) return;
    if(!hasBiz()){ slot.innerHTML = ""; return; }
    if(slot.firstChild) return;

    var part = document.createElement("div");
    part.className = "sq-part sq-venue";
    part.innerHTML = '<p>What kind of business? <span class="sq-opt">Optional</span></p>';
    var row = document.createElement("div");
    row.className = "sq-chips sq-venue";
    row.setAttribute("role","group");
    VENUES.forEach(function(it){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sq-chip";
      b.setAttribute("aria-pressed", state.venue === it.v ? "true" : "false");
      b.innerHTML = chipIcon(it.v) + '<span class="sq-cname">' + esc(it.lbl) + '</span>';
      b.addEventListener("click", function(){
        state.venue = (state.venue === it.v) ? null : it.v;
        markGroup(row, VENUES, state.venue);
        syncContinue();
      });
      row.appendChild(b);
    });
    part.appendChild(row);
    slot.appendChild(part);
  }

  function renderTiles(q){
    var grid = document.createElement("div");
    grid.className = "sq-tiles"; grid.setAttribute("role","group");
    q.tiles.forEach(function(t){
      var b = tileButton(state[q.key] === t.v, t.wide ? " sq-wide" : "");
      b.innerHTML = tileInner(t.art(), t.name, t.spec, false, {desc:t.desc});
      b.addEventListener("click", function(){ pick(q.key, t.v, grid, q.tiles); });
      grid.appendChild(b);
    });
    el.body.appendChild(grid);
  }

  function renderScent(){
    var keys = ["floral","fruity","citrus","fresh","woody","gourmand","unsure"];
    var grid = document.createElement("div");
    grid.className = "sq-tiles sq-three"; grid.setAttribute("role","group");
    keys.forEach(function(k){
      var pr = PROFILES[k];
      var b = tileButton(state.scent === k, " sq-scent");
      b.style.setProperty("--tint", pr.color);
      b.style.setProperty("--tint-soft", "rgba(" + pr.rgb + ",.10)");
      b.style.setProperty("--tint-wash", "rgba(" + pr.rgb + ",.22)");
      b.innerHTML = pr.open
        ? tileInner(profileArt(k), pr.name, pr.spec, false, {desc:"Sample the six with your consultant"})
        : tileInner(profileArt(k), pr.name, pr.mood, false, {mood:true});
      b.addEventListener("click", function(){
        setProfileTheme(k);
        pick("scent", k, grid, keys.map(function(x){return {v:x};}));
      });
      grid.appendChild(b);
    });
    el.body.appendChild(grid);
  }

  function renderPair(){
    var f = document.createDocumentFragment();

    var p1 = document.createElement("div"); p1.className = "sq-part"; p1.style.marginTop = "0";
    p1.innerHTML = "<p>Using today</p>";
    var r1 = document.createElement("div"); r1.className = "sq-chips"; r1.setAttribute("role","group");
    USING.forEach(function(it){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sq-chip";
      b.setAttribute("aria-pressed", state.current === it.v ? "true" : "false");
      b.innerHTML = chipIcon(it.v) + '<span class="sq-cname">' + esc(it.lbl) + '</span>';
      b.addEventListener("click", function(){ state.current = it.v; markGroup(r1, USING, it.v); syncContinue(); });
      r1.appendChild(b);
    });
    p1.appendChild(r1); f.appendChild(p1);

    var p2 = document.createElement("div"); p2.className = "sq-part"; p2.innerHTML = "<p>Spending per month</p>";
    var r2 = document.createElement("div"); r2.className = "sq-chips sq-money"; r2.setAttribute("role","group");
    SPEND.forEach(function(it){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sq-chip";
      b.setAttribute("aria-pressed", state.spend === it.v ? "true" : "false");
      var g = "";
      for(var i=1;i<=4;i++){ g += '<i class="' + (i <= it.n ? "sq-on" : "") + '"></i>'; }
      b.innerHTML = '<span class="sq-amt">' + esc(it.lbl) + '</span><span class="sq-gauge">' + g + '</span>';
      b.addEventListener("click", function(){ state.spend = it.v; markGroup(r2, SPEND, it.v); syncContinue(); });
      r2.appendChild(b);
    });
    p2.appendChild(r2); f.appendChild(p2);

    el.body.appendChild(f);
    el.cont.hidden = false;
    syncContinue();
  }

  function markGroup(row, items, v){
    var kids = row.children;
    for(var i=0;i<kids.length;i++){ kids[i].setAttribute("aria-pressed", items[i].v === v ? "true" : "false"); }
  }

  function syncContinue(){
    var q = QUESTIONS[step];
    if(q.multi){ el.cont.disabled = !state.sizes.length; }
    else if(q.pair){ el.cont.disabled = !(state.current && state.spend); }
  }
  el.cont.addEventListener("click", function(){ if(!el.cont.disabled) advance(); });

  function pick(key, v, grid, items){
    state[key] = v;
    markGroup(grid, items, v);
    window.setTimeout(advance, 280);
  }

  function setProfileTheme(k){
    var pr = PROFILES[k];
    ROOT.style.setProperty("--profile", pr.color);
    ROOT.style.setProperty("--profile-wash", "rgba(" + pr.rgb + ",.16)");
  }

  function advance(){
    track("quiz_question_complete", {question_number: step + 1, question_key: QUESTIONS[step].key, answer: answerFor(QUESTIONS[step].key)});
    step++;
    if(step < QUESTIONS.length){ renderQuestion(); } else { showReveal(); }
    ROOT.scrollIntoView({behavior:"smooth", block:"start"});
  }
  el.back.addEventListener("click", function(){ if(step > 0){ step--; renderQuestion(); } });

  /* ---------- recommendation ---------- */
  /* Size x delivery matrix.
     DaVinci 2.0 is standalone only, VanGogh 2.0 runs either way,
     Museum 2.0 and Museum360 XL are HVAC-integrated only — so a
     one-room or few-room answer can never land on an HVAC-only unit. */
  /* An apartment is a rental, so the building's HVAC is almost never
     available to the tenant — every apartment row stays standalone-capable. */
  var RESI_MATRIX = {
    /*           apartment      condo       home        large        estate   */
    one:    {apt:"davinci", s:"davinci", m:"davinci", l:"vangogh", xl:"vangogh"},
    key:    {apt:"davinci", s:"davinci", m:"vangogh", l:"vangogh", xl:"vangogh"},
    hvac:   {apt:"vangogh", s:"vangogh", m:"vangogh", l:"museum",  xl:"museumxl"},
    unsure: {apt:"davinci", s:"davinci", m:"vangogh", l:"vangogh", xl:"museum"}
  };
  function resiDiffuser(){
    var r = resiSizes();
    if(!r.length) return null;
    var top = r.sort(function(a,b){ return RESI_ORDER.indexOf(a) - RESI_ORDER.indexOf(b); }).pop();
    var row = RESI_MATRIX[state.method] || RESI_MATRIX.unsure;
    return DIFFUSERS[row[top] || "vangogh"];
  }
  function bizDiffuser(){
    if(!hasBiz()) return null;
    return DIFFUSERS[VENUE_UNIT[state.venue] || "vangogh"];
  }

  function leadScore(){
    var n = 0, r = resiSizes();
    if(r.indexOf("xl") > -1) n += 3; else if(r.indexOf("l") > -1) n += 2; else if(r.indexOf("m") > -1) n += 1;
    if(hasBiz()) n += 4;
    if(state.method === "hvac") n += 3; else if(state.method === "key") n += 2; else if(state.method === "unsure") n += 1;
    if(state.spend === "vhi") n += 3; else if(state.spend === "hi") n += 2; else if(state.spend === "mid") n += 1;
    if(state.timeline === "today") n += 4; else if(state.timeline === "asap") n += 3;
    else if(state.timeline === "30") n += 2; else if(state.timeline === "90") n += 1;
    if(state.current !== "none") n += 1;
    return n;
  }
  function tierOf(n){
    if(n >= 12) return {k:"a", label:"Priority A · call within the hour"};
    if(n >= 6)  return {k:"b", label:"Priority B · call same day"};
    return {k:"c", label:"Priority C · nurture sequence"};
  }
  function callWhen(){
    return state.timeline === "today" ? "today" :
           state.timeline === "asap"  ? "today or tomorrow" :
           state.timeline === "30"    ? "within one business day" :
           state.timeline === "90"    ? "this week" : "whenever it suits you";
  }

  var TRUST = '<ul class="sq-trust"><li>6 million spaces scented</li><li>Child &amp; pet safe</li>' +
              '<li>Cruelty free</li><li>Waterless cold-air</li></ul>';

  function heroHTML(pr, tag){
    return '<div class="sq-hero"><span class="sq-art">' + profileArt(state.scent) + '</span><div>' +
        '<p class="sq-tag' + (pr.open ? "" : " sq-tag-mood") + '">' + (pr.open ? "" : moodIcon(pr.mood)) +
          '<span>' + tag + '</span></p><h3>' + esc(pr.name) + '</h3>' +
        '<p class="sq-mood">' + esc(pr.benefit) + '</p>' +
        '<ul class="sq-vocab">' + pr.vocab.map(function(w){return "<li>" + esc(w) + "</li>";}).join("") + '</ul>' +
      '</div></div>';
  }

  function bizNoun(){
    return (state.venue && state.venue !== "other") ? VENUE_LABEL[state.venue].toLowerCase() : "business";
  }

  function matchCard(d, isPro){
    return '<div class="sq-match' + (isPro ? " sq-pro" : "") + '">' +
        '<span class="sq-art">' + unit(d.key) + '</span>' +
        (isPro ? '<span class="sq-prolabel">Aroma360 Pro</span>' : "") +
        '<p class="sq-tag">' + (isPro ? "For your " + esc(bizNoun()) : "For your home") + '</p>' +
        '<h4>' + esc(d.name) + '</h4>' +
        '<dl><dt>Covers</dt><dd>' + esc(d.cover) + '</dd>' +
            '<dt>Delivery</dt><dd>' + esc(d.tech) + '</dd>' +
            '<dt>Oil</dt><dd>' + esc(d.oil) + '</dd></dl>' +
      '</div>';
  }

  /* ---------- stage 1 ---------- */
  function showReveal(){
    var pr = PROFILES[state.scent];
    el.reveal.innerHTML =
      '<div class="sq-reveal">' +
        '<div class="sq-head"><p class="sq-eyebrow">Your profile</p>' +
        '<h2 class="sq-ask">' + (pr.open
            ? 'Let&rsquo;s find your <em>profile</em> together.'
            : 'You are <em>' + esc(pr.name) + '</em>.') + '</h2></div>' +
        heroHTML(pr, pr.open ? "Profile &middot; chosen with your consultant" : "Mood · " + esc(pr.mood)) +
        '<div class="sq-locked"><div class="sq-veil" aria-hidden="true">' + unit("vangogh") +
          '<div class="sq-rows"><span></span><span></span><span></span></div></div>' +
          '<div class="sq-stamp"><span>' + (hasBiz() && resiSizes().length ? "Your two matches" : "Your diffuser match") + '</span></div></div>' +
        '<div class="sq-formwrap">' +
          '<h3>Unlock your match</h3>' +
          '<p class="sq-lede">Your details let a consultant confirm coverage for your space. Nothing is ordered and nothing is charged here.</p>' + TRUST +
          '<form class="sq-fields" id="stage1" novalidate>' +
            '<div class="sq-f"><label for="fn">First name</label><input id="fn" autocomplete="given-name" placeholder="Jordan"><span class="sq-err"></span></div>' +
            '<div class="sq-f"><label for="ln">Last name</label><input id="ln" autocomplete="family-name" placeholder="Reyes"><span class="sq-err"></span></div>' +
            '<div class="sq-f sq-wide"><label for="em">Email</label><input id="em" type="email" autocomplete="email" inputmode="email" placeholder="jordan@example.com">' +
              '<span class="sq-why">Where we send your profile.</span><span class="sq-err"></span></div>' +
            '<div class="sq-f sq-wide"><label for="ph">Phone</label><input id="ph" type="tel" autocomplete="tel" inputmode="tel" placeholder="(305) 555-0142">' +
              '<span class="sq-why">How your consultant reaches you.</span><span class="sq-err"></span></div>' +
            '<div class="sq-f sq-wide"><label for="st">Street address</label><input id="st" autocomplete="street-address" placeholder="1200 Brickell Ave, Apt 14B">' +
              '<span class="sq-why">Used to size your space and match a local consultant.</span><span class="sq-err"></span></div>' +
            '<div class="sq-trio">' +
              '<div class="sq-f"><label for="ci">City</label><input id="ci" autocomplete="address-level2" placeholder="Miami"><span class="sq-err"></span></div>' +
              '<div class="sq-f"><label for="sr">State</label><input id="sr" autocomplete="address-level1" maxlength="2" placeholder="FL"><span class="sq-err"></span></div>' +
              '<div class="sq-f"><label for="zp">ZIP</label><input id="zp" autocomplete="postal-code" inputmode="numeric" maxlength="5" placeholder="33131"><span class="sq-err"></span></div>' +
            '</div>' +
            '<input class="sq-hp" type="text" name="companyName2" id="honeypot" tabindex="-1" autocomplete="off" aria-hidden="true">' +
            '<div class="sq-gcaptcha" id="recaptcha_' + cfg.sectionId + '"></div>' +
            '<p class="sq-submit-err" id="submitErr" role="alert"></p>' +
            (cfg.consentCheckbox && cfg.consentText
              ? '<label class="sq-consent"><input type="checkbox" id="consent"><span>' + cfg.consentText + '</span></label>' +
                '<p class="sq-consent-err" id="consentErr" role="alert"></p>'
              : '') +
            '<button class="sq-btn sq-submit" type="submit" id="submitBtn">See my match</button>' +
            (!cfg.consentCheckbox && cfg.consentText ? '<p class="sq-fineprint">' + cfg.consentText + '</p>' : '') +
            '<p class="sq-fineprint">This does not place an order. A consultant reviews your match with you first, then sets up the order and payment together with you.</p>' +
          '</form></div>' +
        '<div class="sq-nav"><button class="sq-back" id="backToQuiz" type="button">&larr; Back</button></div>' +
      '</div>';

    el.quiz.hidden = true; el.reveal.hidden = false;
    step = 5; paintRail();
    track("quiz_form_view");

    ROOT.querySelector("#backToQuiz").addEventListener("click", function(){
      el.reveal.hidden = true; el.quiz.hidden = false;
      step = QUESTIONS.length - 1; renderQuestion();
      ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    });

    renderRecaptcha();
    /* address autocomplete lives in scent-quiz-places.js, which the section only loads when a Places API key is set */
    if(cfg.placesApiKey && typeof window.initScentQuizPlaces === "function"){
      window.initScentQuizPlaces({root: ROOT, cfg: cfg, esc: esc, track: track});
    }
    var f1 = ROOT.querySelector("#stage1");
    f1.addEventListener("input", maybeClear);
    f1.addEventListener("submit", function(e){
      e.preventDefault();
      if(!validate([
        {id:"fn", t:function(v){return v.length>=2;},                             m:"Enter your first name."},
        {id:"ln", t:function(v){return v.length>=2;},                             m:"Enter your last name."},
        {id:"em", t:function(v){return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);}, m:"Enter a valid email."},
        {id:"ph", t:function(v){return v.replace(/\D/g,"").length>=10;},           m:"Enter a 10-digit phone number."},
        {id:"st", t:function(v){return v.length>=5;},                             m:"Enter your street address."},
        {id:"ci", t:function(v){return v.length>=2;},                             m:"Enter your city."},
        {id:"sr", t:function(v){return /^[A-Za-z]{2}$/.test(v);},                 m:"2-letter state."},
        {id:"zp", t:function(v){return /^\d{5}$/.test(v);},                       m:"Enter a 5-digit ZIP."}
      ])) return;
      ["fn","ln","em","ph","st","ci","zp"].forEach(function(k){ lead[k] = ROOT.querySelector("#" + k).value.trim(); });
      lead.sr = ROOT.querySelector("#sr").value.trim().toUpperCase();
      var consented = true;
      if(cfg.consentCheckbox && cfg.consentText){
        var box = ROOT.querySelector("#consent");
        consented = box.checked;
        ROOT.querySelector("#consentErr").textContent = consented ? "" : "Please agree to be contacted to continue.";
        if(!consented){ box.focus(); track("quiz_form_error", {field: "consent"}); return; }
      }
      submitLead(consented);
    });
  }


  /* ===== ANALYTICS — dataLayer events from the build spec (platform still an open question) ===== */
  var started = false;
  function track(name, params){
    try{
      window.dataLayer = window.dataLayer || [];
      var e = {event: name, form_id: cfg.formId, quiz_version: cfg.quizVersion};
      for(var k in (params || {})){ e[k] = params[k]; }
      window.dataLayer.push(e);
    }catch(err){}
  }
  function answerFor(key){
    if(key === "sizes") return state.sizes.join(",") + (state.venue ? ":" + state.venue : "");
    if(key === "method") return state.method;
    if(key === "scent") return state.scent;
    if(key === "__pair") return state.current + "|" + state.spend;
    if(key === "timeline") return state.timeline;
    return "";
  }

  /* ===== SALESFORCE SUBMISSION (same ingester + flat field names as dynamic-form.js,
     plus the spec-shaped formId / answers / derived / consent objects from the build spec) ===== */
  var widgetId = null, submitted = false;
  function renderRecaptcha(){
    widgetId = null;
    var tryRender = function(){
      if(window.grecaptcha && grecaptcha.enterprise && typeof grecaptcha.enterprise.render === "function"){
        var host = ROOT.querySelector("#recaptcha_" + cfg.sectionId);
        if(host && widgetId === null) widgetId = grecaptcha.enterprise.render(host, {sitekey: cfg.recaptchaSiteKey});
        return true;
      }
      return false;
    };
    if(tryRender()) return;
    var t = setInterval(function(){ if(tryRender()) clearInterval(t); }, 300);
    setTimeout(function(){ clearInterval(t); }, 15000);
  }

  function pad(n){ return (n < 10 ? "0" : "") + n; }
  /* ISO 8601 with the client's UTC offset, e.g. 2026-10-14T15:04:22-04:00 */
  function isoLocal(d){
    var off = -d.getTimezoneOffset(), sign = off >= 0 ? "+" : "-", a = Math.abs(off);
    return d.getFullYear() + "-" + pad(d.getMonth()+1) + "-" + pad(d.getDate()) + "T" +
           pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds()) +
           sign + pad(Math.floor(a/60)) + ":" + pad(a%60);
  }
  /* US numbers -> E.164 */
  function e164(raw){
    var d = String(raw).replace(/\D/g, "");
    if(d.length === 10) return "+1" + d;
    return "+" + d;
  }
  function plainConsent(){ return (cfg.consentText || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim(); }

  function unitNames(){
    var rd = resiDiffuser(), bd = bizDiffuser(), rec = [];
    if(rd) rec.push(rd.name + " (residential)");
    if(bd) rec.push(bd.name + " (commercial)");
    return rec.join(" + ");
  }

  /* human-readable summary -> Salesforce lead comments */
  function buildComments(){
    var pr = PROFILES[state.scent], score = leadScore(), tier = tierOf(score), bd = bizDiffuser();
    var spaces = state.sizes.map(function(v){
      return v === "biz" ? ("Business - " + (state.venue ? VENUE_LABEL[state.venue] : "type not given")) : SIZE_LABEL[v];
    }).join(", ");
    var lines = [
      "SCENT QUIZ",
      "Lead score: " + score + " of 18 (" + tier.label + ")",
      "Scenting: " + spaces,
      "Setup: " + METHOD_LABEL[state.method],
      "Scent profile: " + (pr.open ? "Not chosen - sample all six on the call" : pr.name + " (" + pr.mood + ", " + pr.colorName + ")"),
      "Using now: " + CURRENT_LABEL[state.current],
      "Monthly spend: " + SPEND_LABEL[state.spend],
      "Timeline: " + TIME_LABEL[state.timeline] + " - customer was told: expect a call " + callWhen(),
      "Recommended: " + unitNames(),
      bd ? "Route: Aroma360 Pro (book walkthrough first)" : ""
    ].filter(Boolean);
    lines.push("", "CONSULTANT NOTE");
    [
      bd ? "Commercial lead - book the walkthrough first; the " + bd.name + " quote follows from square footage." : "",
      (SPEND_MID[state.spend] && state.current !== "none") ? "Already spends about $" + SPEND_MID[state.spend] + "/mo on " + CURRENT_LABEL[state.current].toLowerCase() + " - use as the anchor." : "",
      "No pricing was shown to the customer; present the plan and included diffuser on the call.",
      pr.open ? "No profile chosen - open with the six-profile sampler and let them pick live." : "Pair from the profile: " + pr.name + "."
    ].filter(Boolean).forEach(function(l){ lines.push(l); });
    return lines.join("\n");
  }

  function buildPayload(consented){
    var pr = PROFILES[state.scent], score = leadScore(), tier = tierOf(score);
    var rd = resiDiffuser(), bd = bizDiffuser(), now = new Date(), stamp = isoLocal(now);
    var p = {
      first_name: lead.fn, last_name: lead.ln, email: lead.em, phone_mobile: e164(lead.ph),
      street: lead.st, city: lead.ci, state: lead.sr, postcode: lead.zp, country: "US",
      /* Salesforce requires a Company: "Consumer", or the venue type for business leads */
      business: hasBiz() ? (state.venue ? VENUE_LABEL[state.venue] : "Business") : "Consumer",
      lead_comments: buildComments(),
      lead_source: cfg.leadSource,
      lead_category: cfg.leadCategory,
      lead_status: cfg.leadStatus,
      business_unit: cfg.businessUnit,
      referrer_url: document.referrer,
      companyName2: ROOT.querySelector("#honeypot").value,
      /* ---- spec-shaped objects (Build Specification section 6.1) ---- */
      form_id: cfg.formId,   /* same field name every other lead form sends */
      formId: cfg.formId,
      quizVersion: cfg.quizVersion,
      completedAt: stamp,
      answers: {
        spaceTypes: state.sizes.slice(),
        venue: hasBiz() ? state.venue : null,
        coverageIntent: state.method,
        scentProfile: state.scent,
        currentMethod: state.current,
        currentSpend: state.spend,
        timeline: state.timeline
      },
      derived: {
        recUnitResi: rd ? rd.key : null,
        recUnitPro: bd ? bd.key : null,
        leadScore: score,
        priorityTier: tier.k.toUpperCase(),
        callbackSLA: callWhen(),
        spendAnchor: SPEND_MID[state.spend]
      },
      consent: {
        tcpa: consented,
        mode: cfg.consentCheckbox ? "checkbox" : "implied",
        capturedAt: stamp,
        language: plainConsent()
      }
    };
    if(typeof utilFetchCookieValue === "function"){
      p.cookies = document.cookie.replace(/"/g, '\\"');
      p.last_url = window.location.href;
      p.ga_id = utilFetchCookieValue("_ga");
      p.affiliate_id = utilFetchCookieValue("affiliate_id");
      p.affiliate_data = { page_url: utilFetchCookieValue("affiliate_data") };
      var click = typeof utilGetLatestClickID === "function" ? utilGetLatestClickID() : null;
      if(click){ p.click_id = click.clickID.value; p.platform = click.platform; }
      var map = {utm_campaign:"utm_campaign", utm_medium:"utm_medium", utm_source:"utm_source", utm_term:"utm_term",
                 utm_content:"utm_content", gclid:"shopify_gclid__c", fbclid:"facebook_fbclid", landing_url:"landing_url"};
      Object.keys(map).forEach(function(k){ p[map[k]] = utilFetchCookieValue(k); });
    }
    if(window.Shopify && Shopify.locale) p.preferred_language = Shopify.locale;
    p["g-recaptcha-response"] = (widgetId !== null && window.grecaptcha) ? grecaptcha.enterprise.getResponse(widgetId) : "";
    return p;
  }

  function onSent(data){
    try{
      if(typeof fbq === "function") fbq("track", "Lead");
      track("quiz_submit", {priority_tier: tierOf(leadScore()).k.toUpperCase(), scent_profile: state.scent, lead_key: data.lead_key || ""});
      if(data.lead_key && typeof utilSetCookie === "function") utilSetCookie("last_lead_key", data.lead_key, 365);
    }catch(e){ console.error(e); }
  }
  function onFailed(reason, attempt, retryable){
    console.error("[scent-quiz] lead submission failed after " + attempt + " attempt(s):", reason);
    track("quiz_submit_failed", {reason: String(reason).slice(0, 200), attempts: attempt, retryable: retryable});
  }

  /* The result is shown immediately (build spec 6.2); the lead is sent in the background.
     Network errors retry up to 3 times with backoff. A rejection from the ingester is not retried. */
  function sendLead(payload, attempt){
    var url = cfg.formUrl + (cfg.formSource ? "?source=" + encodeURIComponent(cfg.formSource) : "");
    fetch(url, {method:"POST", mode:"cors", headers:{"Content-Type":"application/json"}, body:JSON.stringify(payload)})
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status === "success"){ onSent(data); }
        else { onFailed(data.message || "rejected by ingester", attempt, false); }
      })
      .catch(function(e){
        if(attempt < 3){ setTimeout(function(){ sendLead(payload, attempt + 1); }, attempt === 1 ? 2000 : 6000); }
        else { onFailed(e, attempt, true); }
      });
  }

  function submitLead(consented){
    if(submitted) return;
    var err = ROOT.querySelector("#submitErr"), btn = ROOT.querySelector("#submitBtn");
    err.textContent = "";
    if(widgetId === null || !grecaptcha.enterprise.getResponse(widgetId)){
      err.textContent = "Please confirm you are not a robot.";
      track("quiz_form_error", {field: "recaptcha"});
      return;
    }
    submitted = true;
    btn.disabled = true;
    var payload = buildPayload(consented);
    showResult();
    sendLead(payload, 1);
  }


  /* the field wrapper is the nearest .sq-f (the street input may sit inside an extra autocomplete wrapper) */
  function fieldOf(i){ return i.closest ? i.closest(".sq-f") : i.parentNode; }
  function fail(i,m){ var w=fieldOf(i); w.classList.add("sq-bad"); w.querySelector(".sq-err").textContent=m; }
  function clearField(i){ var w=fieldOf(i); w.classList.remove("sq-bad"); w.querySelector(".sq-err").textContent=""; }
  function maybeClear(e){
    var w = e.target.closest ? e.target.closest(".sq-f") : null;
    if(w && w.classList.contains("sq-bad")) clearField(e.target);
  }
  function validate(checks){
    var ok = true, first = null;
    checks.forEach(function(c){
      var n = ROOT.querySelector("#" + c.id);
      if(c.t(n.value.trim())) clearField(n);
      else { fail(n,c.m); ok = false; if(!first) first = n; track("quiz_form_error", {field: c.id}); }
    });
    if(first) first.focus();
    return ok;
  }

  /* ---------- result ---------- */
  function showResult(){
    var pr = PROFILES[state.scent];
    var rd = resiDiffuser(), bd = bizDiffuser();
    var both = !!(rd && bd);
    var lead_unit = rd || bd;

    var headline = both
      ? esc(lead.fn) + ', here are your <em>two matches</em>.'
      : esc(lead.fn) + ', meet the <em>' + esc(lead_unit.name) + '</em>.';

    var coverLine =
      state.method === "hvac" ? "Wired into your air handler, it reaches every room the system serves." :
      state.method === "key"  ? "One unit placed centrally covers your entry, main room and bedroom." :
      state.method === "one"  ? "A standalone unit for your main room, movable any time." :
                                "Your consultant will confirm HVAC or standalone placement from your floor plan.";

    var cards = "";
    if(rd) cards += matchCard(rd, false);
    if(bd) cards += matchCard(bd, true);

    el.result.innerHTML =
      '<div class="sq-reveal">' +
        '<div class="sq-head"><p class="sq-eyebrow">Your match</p>' +
        '<h2 class="sq-ask">' + headline + '</h2></div>' +
        heroHTML(pr, esc(lead.fn) + "&rsquo;s profile &middot; " +
          (pr.open ? "chosen with your consultant" : esc(pr.mood))) +
        '<div class="sq-matches' + (both ? " sq-two" : "") + '">' + cards + '</div>' +
        '<div class="sq-coverage"><span class="sq-art">' + plan(state.method === "unsure" ? "hvac" : state.method) + '</span>' +
          '<p><strong>Your coverage.</strong> ' + esc(coverLine) +
          (bd ? " Your " + esc(bizNoun()) + " is sized separately after a walkthrough." : "") +
          '</p></div>' +
        '<div class="sq-confirmed">' +
          '<h3>This is a <em>recommendation</em>, not an order.</h3>' +
          '<p>No order has been placed and no payment has been taken. Your consultant will review ' +
            (both ? 'these matches' : 'this match') + ' with you, confirm the right fit for ' +
            esc(lead.ci) + ' ' + esc(lead.sr) + ', and place the order for you once you decide to go ahead.</p>' +
        '</div>' +
        '<div class="sq-thanks">' +
          '<p class="sq-tag">Thank you, ' + esc(lead.fn) + '</p>' +
          '<h3>A scent consultant will be <em>reaching out soon</em>.</h3>' +
          '<p class="sq-lede">Your profile is with our team now. Expect a call ' + esc(callWhen()) +
            ' on ' + esc(lead.ph) + ' &mdash; your consultant will confirm placement, walk you through your ' +
            (pr.open ? "fragrance" : esc(pr.name.toLowerCase())) + ' options and go over the plan with you.</p>' +
          '<ul class="sq-next">' +
            '<li><span>1</span>A copy of your profile is on its way to ' + esc(lead.em) + '.</li>' +
            '<li><span>2</span>Your consultant confirms coverage and the right unit for your space.</li>' +
            '<li><span>3</span>If you decide to go ahead, they place the order and handle payment with you on the call.</li>' +
          '</ul>' +
        '</div>' +
        '<div id="tail"></div>' +
      '</div>';

    el.reveal.hidden = true; el.result.hidden = false;
    ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    renderTail();
  }

  function renderTail(){
    ROOT.querySelector("#tail").innerHTML = '<button class="sq-restart" type="button" id="restart">Start over</button>';
    ROOT.querySelector("#restart").addEventListener("click", function(){
      state = {sizes:[], venue:null, method:null, scent:null, current:null, spend:null, timeline:null};
      lead  = {fn:"", ln:"", em:"", ph:"", st:"", ci:"", sr:"", zp:""};
      step = 0;
      submitted = false;
      ROOT.style.setProperty("--profile", "#A48776");
      ROOT.style.setProperty("--profile-wash", "rgba(164,135,118,.13)");
      el.result.hidden = true; el.reveal.hidden = true; el.quiz.hidden = false;
      renderQuestion();
      ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    });
  }

  buildRail();
  renderQuestion();
};
